import { api } from "./api";
import drupalBaseEndpoint from "./base";
import { getApiLanguage } from "./i18n";
import { TranslatePathResponse } from "../shared/router";

export const translatePath = (path: string) =>
  api<TranslatePathResponse>(`${drupalBaseEndpoint}/${getApiLanguage()}/router/translate-path?path=${path}`);
